import * as e from "react";
import m from "../lib/IconBase.es.js";
import t from "../defs/Terminal.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(m, { ref: a, ...r, weights: t }));
o.displayName = "TerminalIcon";
const c = o;
export {
  c as Terminal,
  o as TerminalIcon
};
